import type { FC, ReactElement } from "react"

import { Typography } from "@/3514/components/shared/typography/typography.component"
import {
    ETypographyAlignment,
    ETypographyColor,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight
} from "@/3514/components/shared/typography/typography.types"
import { type IUseTranslation, useTranslation } from "@/hooks"

import { coachConferenceAccountConfig as config } from "./coach.conference-account.config"
import { ECoachConferenceAccountVariant as EVariant } from "./coach.conference-account.types"

const { imagesMap, titlesMap } = config

const classes = {
    titleWrapper: "flex gap-x-[5px] items-center",
    title: "!mb-[0px] ml-[5px] select-none"
}

type _TProps = { variant: EVariant; titleSize: ETypographySize; titleTag: ETypographyTag }

const Name: FC<_TProps> = ({ variant, titleSize, titleTag }: _TProps): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return (
        <div className={classes.titleWrapper}>
            {imagesMap[variant]}

            <Typography
                text={t(titlesMap[variant])}
                tag={titleTag}
                size={titleSize}
                alignment={ETypographyAlignment.Center}
                weight={ETypographyWeight.Medium}
                family={ETypographyFamily.DmSerif}
                color={ETypographyColor.Black}
                className={classes.title}
            />
        </div>
    )
}

Name.displayName = "CoachConferenceAccountName"

export { Name as CoachConferenceAccountName }
